import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";

const AuthService = {};

AuthService.login = function (data) {
  // Limpar qualquer cache existente para garantir dados frescos
  try {
    sessionStorage.removeItem("dashboard_indicators_data");
    sessionStorage.removeItem("dashboard_store_indicators");
    sessionStorage.removeItem("dashboard_config_cache");
  } catch (e) {
    console.error("[AuthService] Erro ao limpar cache:", e);
  }

  return fetch({
    url: `${API_BASE_URL}/Authentication/Token`,
    method: "post",
    mode: "no-cors",
    headers: {
      "public-request": "true",
      "Content-Type": "application/json",
    },
    data: data,
  }).then((response) => {
    // Registrar o momento do login para permitir que os componentes
    // saibam que é o primeiro carregamento após login
    localStorage.setItem("last_login_time", Date.now().toString());
    console.log("[AuthService] Login bem-sucedido, timestamp registrado");
    return response;
  });
};

export default AuthService;
